module.exports = __webpack_public_path__ + "media/images/proposal/top/reason1-4ce512b5c1e5e9e211831b2e77d33aa3.jpg";